import { AHText, AHTextFonts, useLayoutContext } from "arkh";
import Color from "color";
import React from "react";
import { Pressable } from "react-native";

export const CategoryOption = ({
  category,
  selected,
  onPress,
}: {
  category: { id: string; color: string; title: string };
  selected: boolean;
  onPress(): void;
}) => {
  const layout = useLayoutContext();
  return (
    <Pressable
      key={category.id}
      disabled={selected}
      onPress={onPress}
      style={({ pressed }) => ({
        paddingHorizontal: layout.space.small,
        borderRadius: layout.radius.medium,
        marginRight: layout.space.medium,
        marginBottom: layout.space.medium,
        backgroundColor: pressed
          ? Color(category.color).lightness(97).toString()
          : selected
            ? category.color
            : undefined,
        borderColor: category.color,
        borderWidth: 2,
        width: 140,
        height: 50,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      })}
    >
      <AHText
        numberOfLines={2}
        type="title-small"
        style={{
          textAlign: "center",
          flex: 1,
        }}
        color={selected ? "lightText" : "darkText"}
        font={selected ? AHTextFonts.BOLDER : AHTextFonts.MEDIUM}
      >
        {category.title}
      </AHText>
    </Pressable>
  );
};
